<template>
  <section id="contact" class="section contact">
    <div class="container-fluid">
      <div class="heading">
        <h2>Contact</h2>
        <p>Get in Touch</p>
      </div>
    <div class="social">

      <ul>
        <li><a href="https://www.youtube.com/channel/UCsWZ_1lgJDqXNJwmUD2dIHw" target="_blank"><i class="fa-brands fa-youtube" aria-hidden="true"></i></a></li>
        <li><a href="https://www.facebook.com/mohammadaliITE" target="_blank"><i class="fa-brands  fa-facebook" aria-hidden="true"></i></a></li>
        <li><a href="https://github.com/MohammadAliCoder" target="_blank"><i class="fa-brands  fa-github-alt" aria-hidden="true"></i></a></li>
        <li><a href="https://www.linkedin.com/in/mohammad-ali-9843a6203/" target="_blank"><i class="fa-brands  fa-linkedin-in" aria-hidden="true"></i></a></li>
        <li><a href="whatsapp://send?phone=+963932145230" target="_blank"><i class="fa-brands  fa-whatsapp" aria-hidden="true"></i></a></li>
        <li><a href="mailto:mohammadanouali@gmail.com" target="_blank"><i class="fa-solid  fa-envelope-open" aria-hidden="true"></i></a></li>
      </ul>
    </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "VueContact"
}
</script>

<style scoped>
.contact{
padding: 50px 0;
}
.social{
  position: relative;
  width: 100%;
  padding: 50px 0;
  min-height: 90px;

}
ul
{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  margin:0;
  padding:0;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  height: 100%;
  justify-content: center;
  align-items: center;
  width: 100%;
}
ul li
{
  list-style:none;
  margin:0 40px;
}
ul li a .fa-brands,ul li a .fa-solid
{
  font-size:40px;
  color:var(--font-color);
  line-height:60px;
  transition:.5s;
}
ul li a
{
  position:relative;
  display:block;
  width:60px;
  height:60px;
  background:var(--color-bg1);
  text-align:center;
  transform: perspective(1000px) rotate(-30deg) skew(25deg) translate(0,0);
  transition:.5s;
  transition-timing-function: linear;
  box-shadow:-20px 20px 10px rgba(0,0,0,.5);
}
ul li a:before
{
  content:'';
  position:absolute;
  top:10px;
  left:-20px;
  height:100%;
  width:20px;
  background:var(--color-bg2);
  transition: .5s;
  transform: rotate(0deg) skewY(-45deg);
}
ul li a:after
{
  content:'';
  position:absolute;
  bottom:-20px;
  left:-10px;
  height:20px;
  width:100%;
  background:var(--color-bg1);
  transition: .85s;
  transform: rotate(0deg) skewX(-45deg);
}
ul li a:hover
{
  transform: perspective(1000px) rotate(-30deg) skew(25deg) translate(20px,-20px);
  box-shadow:-50px 50px 30px rgba(0,0,0,0.95);
}
ul li:hover .fa-brands
{
  color:#fff;
}
/* youtube */
ul li:hover:nth-child(1) a
{
  background: #cd201f;
}
ul li:hover:nth-child(1) a:before
{
  background: #930504;
}
ul li:hover:nth-child(1) a:after
{
  background: #e62c2a;
}







/* facebook */
ul li:hover:nth-child(2) a
{
  background: #3b5999;
}
ul li:hover:nth-child(2) a:before
{
  background: #2c3e64;
}
ul li:hover:nth-child(2) a:after
{
  background: #516aa5;
}

/* github */
ul li:hover:nth-child(3) a
{
  background: #4b4e58;
}
ul li:hover:nth-child(3) a:before
{
  background: #28292a;
}
ul li:hover:nth-child(3) a:after
{
  background: #5c5f6d;
}

/* whatsapp */
ul li:hover:nth-child(4) a
{
  background: #0e76a8;
}
ul li:hover:nth-child(4) a:before
{
  background: #0d577a;
}
ul li:hover:nth-child(4) a:after
{
  background: #0e76a8;
}
/* whatsapp */
ul li:hover:nth-child(5) a
{
  background: #25D366;
}
ul li:hover:nth-child(5) a:before
{
  background: #0d6930;
}
ul li:hover:nth-child(5) a:after
{
  background: #25D366;
}

ul li:hover:nth-child(6) a
{
  background: #cd201f;
}
ul li:hover:nth-child(6) a:before
{
  background: #930504;
}
ul li:hover:nth-child(6) a:after
{
  background: #e62c2a;
}

@media (max-width: 450px) {
  .social{
    position: relative;
    width: 100%;
    padding: 100px 0;
    min-height: 500px;

  }
}


</style>